"use client"

import { Gift, X } from "lucide-react"

import { useCart } from "@/features/cart/hooks/use-cart"
import { cn } from "@/lib/utils"

/** The lucky-draw gift in the cart and at checkout: free, and removable. Nothing without one. */
export function GiftLine({ className }: { className?: string }) {
  const gift = useCart((s) => s.gift)
  const setGift = useCart((s) => s.setGift)
  if (!gift) return null

  return (
    <div
      className={cn(
        "border-acid/25 bg-acid/[0.06] flex items-center gap-3 rounded-lg border px-3 py-2.5",
        className,
      )}
    >
      <span className="bg-acid/15 text-acid flex size-9 shrink-0 items-center justify-center rounded-md">
        <Gift className="size-4" strokeWidth={2} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="text-bone block truncate text-sm font-semibold">{gift.name}</span>
        <span className="text-dim block font-mono text-[11px] tracking-[0.08em]">
          LUCKY DRAW · {gift.code}
        </span>
      </span>
      <span className="text-acid font-mono text-[12px] font-bold tracking-[0.08em]">FREE</span>
      <button
        type="button"
        onClick={() => setGift(null)}
        aria-label={`Remove the free ${gift.name}`}
        title="Remove"
        className="text-dim hover:text-bone -mr-1 flex size-8 shrink-0 items-center justify-center rounded-full transition-colors"
      >
        <X className="size-4" strokeWidth={2.2} />
      </button>
    </div>
  )
}
